import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { map, catchError } from 'rxjs/operators';
import { throwError, of, empty } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
	providedIn: 'root'
})
export class InvoiceServicesService {
	ledgerList: any;
	invoiceForm: any;

	constructor(
		private http: Http,
		private httpClient: HttpClient
	) { }

	getFromOkunt(url) {
		let token = localStorage.getItem('token');
		const headers = new HttpHeaders({
			'Authorization': token ? token : ''
		});
		return this.httpClient.get(`${environment.okountUrl}/${url}`)
			.pipe(map(res => {
				return res;
			}),
				catchError((err) => {
					return throwError(err);
				}))
	}

	// getRedisData(url2) {
	// 	let token = localStorage.getItem('token');
	// 	const headers = new HttpHeaders({
	// 		'Content-Type': 'application/json',
	// 		'Authorization': token ? token : ''
	// 	});
	// 	return this.httpClient.get(`${environment.url2}/${url2}`)
	// 		.pipe(map(res => {
	// 			return res;
	// 		}),
	// 			catchError((err) => {
	// 				return throwError(err);
	// 			}))
	// }

	searchLedger(url) {
		let token = localStorage.getItem('token');
		const headers = new HttpHeaders({
			'Authorization': token
		});
		return this.httpClient.get(`${environment.okountUrl}/ledger/${url}`)
			.pipe(map(res => {
				// console.log(res);
				return res;
				// console.log('Res data', res);
			}),
				catchError((err) => {
					return throwError(err);
				}))
	}
	searchAccount(url) {
		let token = localStorage.getItem('token');
		const headers = new HttpHeaders({
			'Authorization': token
		});
		return this.httpClient.get(`${environment.okountUrl}/${url}`)
			.pipe(map(res => {
				// console.log(res);
				return res;
				// console.log('Res data', res);
			}),
				catchError((err) => {
					return throwError(err);
				}))
	}

	

	getAirlineInfo(val) {

		let token = localStorage.getItem('token');
		const headers = new HttpHeaders({
			'Authorization': token ? token : ''
		});
		return this.httpClient.get(`${environment.IBEurl}/air/suggest?in=${val}`)
	}

	getAirportSuggestions(val) {
		return this.httpClient.get(`${environment.AadeshTravelUrl}/api/admin/airport-suggestions/suggest?in=${encodeURIComponent(val)}`)
			.pipe(map(res => {
				return this.mapAirportSuggestionsToOldResponse(res);
			}),
				catchError((err) => {
					return throwError(err);
				}))
	}

	mapAirportSuggestionsToOldResponse(res) {
		let airportList = res && res['results'] && res['results']['data'] ? res['results']['data'] : [];
		return airportList.map(airport => {
			let airportCode = airport && airport['iata'] ? airport['iata'] : '';
			let cityName = airport && airport['cityName'] ? airport['cityName'] : '';
			let airportName = airport && airport['airportName'] ? airport['airportName'] : '';
			let countryCode = airport && airport['countryCode'] ? airport['countryCode'] : '';
			let airportNameWithoutCode = this.removeAirportCodePrefix(airportName, airportCode);
			let resultParts = [];

			if (cityName) {
				resultParts.push(cityName);
			}
			if (airportNameWithoutCode && airportNameWithoutCode.toLowerCase() != cityName.toLowerCase()) {
				resultParts.push(airportNameWithoutCode);
			}
			if (countryCode) {
				resultParts.push(countryCode);
			}

			return {
				"airport_name": null,
				"city_name": null,
				"country_code": null,
				"result": `${resultParts.join(', ')}${airportCode ? ' (' + airportCode + ')' : ''}`,
				"airport_CODE": airportCode
			}
		});
	}

	removeAirportCodePrefix(airportName, airportCode) {
		if (!airportName || !airportCode) {
			return airportName;
		}
		let prefix = `${airportCode}, `;
		return airportName.indexOf(prefix) == 0 ? airportName.substring(prefix.length) : airportName;
	}

	retrievePNR(url) {
		let token = localStorage.getItem('token');
		const headers = new Headers({
			'Content-Type': 'application/json'
		});
		return this.httpClient.get(`${environment.pnrRetrieveUrls.base}${url}`)
			.pipe(map(res => {
				return res;
			}),
				catchError((err) => {
					return throwError(err);
				}))
	}

	postMethod(url, data) {
		let token = localStorage.getItem('token');
		const headers = new Headers({
			'Content-Type': 'application/json'
		});
		return this.httpClient.post(`${environment.okountUrl}/${url}`, data)
			.pipe(map(res => {
				return res;
			}),
				catchError((err) => {
					return throwError(err);
				}))
	}
	putMethod(url, data) {
		
		return this.httpClient.put(`${environment.okountUrl}/${url}`, data)
			.pipe(map(res => {
				return res;
			}),
				catchError((err) => {
					return throwError(err);
				}))
	}
	getMethod(url) {
		let token = localStorage.getItem('token');
		const headers = new Headers({
			'Content-Type': 'application/json'
		});
		return this.httpClient.get(`${environment.okountUrl}/${url}`)
			.pipe(map(res => {
				return res;
			}),
				catchError((err) => {
					return throwError(err);
				}))
	}


}
